/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Team } from '../../models/team';

export interface AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Params {
  orgId: string;
  org: string;
      body: Array<Team>
}

export function addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost(http: HttpClient, rootUrl: string, params: AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
  const rb = new RequestBuilder(rootUrl, addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost.PATH, 'post');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Team>>;
    })
  );
}

addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost.PATH = '/api/v2/secretariat/members/{orgId}/team';
